import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";

export const initEminogluFullscreenSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".eminoglu-fs-slider__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      modules: [Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1500, // Very slow, cinematic crossfade (1.5 seconds)
      autoplay: {
        delay: 4000, // Stay on image for 4 seconds
        disableOnInteraction: false, // Keep playing even if touched
      },
      // Disable dragging/swiping since there is no navigation UI
      allowTouchMove: false,
    });
  });

  console.log("[EminogluFullscreenSlider] Initialized.");
};
